import React, { useState } from "react";
import "./SignInModal.css";
import { Link } from "react-router-dom";
import logo from "../Assets/logo.png";

const SignUpModal = ({ show, onClose }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [error, setError] = useState("");

  const handleSignUp = () => {
    // Validate form fields
    if (!email || !password || !confirmPassword) {
      setError("Please fill in all fields");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (!acceptTerms) {
      setError("Please accept the Terms of Service");
      return;
    }

    // Handle signup logic here
    console.log("Sign up with email:", email);
    setError("");
    // Implement account creation logic
    // navigate("/account"); // Example: redirect after successful signup
  };

  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose} aria-label="Close modal">&times;</button>
        <img src={logo} alt="RedboxGlobal Logo" className="modal-logo" />
        <h2 className="modal-title">Create an account</h2>
        <p className="modal-subtext">
          Please enter your details to create an account.
        </p>

        {/* Error Message */}
        {error && <div className="error-message">{error}</div>}

        {/* Email Input */}
        <input
          type="email"
          placeholder="Enter your email"
          className="modal-email-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {/* Password Input */}
        <input
          type="password"
          placeholder="Create a password"
          className="modal-email-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {/* Confirm Password Input */}
        <input
          type="password"
          placeholder="Confirm your password"
          className="modal-email-input"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />

        {/* Terms Checkbox */}
        <div className="modal-checkbox-row">
          <input
            type="checkbox"
            id="terms"
            checked={acceptTerms}
            onChange={(e) => setAcceptTerms(e.target.checked)}
          />
          <label htmlFor="terms">
            I agree to the{" "}
            <Link to="/terms-of-service" className="terms-link" onClick={onClose}>
              Terms of Service
            </Link>
          </label>
        </div>

        {/* Sign Up Button */}
        <button className="modal-continue-btn" onClick={handleSignUp} disabled={!email || !password || !confirmPassword || !acceptTerms}>
          Create Account
        </button>

        {/* OR Divider */}
        <div className="modal-or-divider">
          <span>OR</span>
        </div>

        {/* Social Buttons */}
        <div className="modal-social-buttons">
          <button className="modal-social-btn apple">
            Sign up with Apple
          </button>
          <button className="modal-social-btn google">
            Sign up with Google
          </button>
          <button className="modal-social-btn facebook">
            Sign up with Facebook
          </button>
        </div>

        {/* Footer Links */}
        <div className="modal-footer-links">
          <span>Already have an account?</span>
          <Link to="/signin" className="signin-link" onClick={onClose}>
            Sign in
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SignUpModal;
